export default class ApiCargaService {
  constructor(http) {
    this._http = http
  }

  async salvar(autorizacaoPortabilidade) {
    const { data } = await this._http.post(
      `/api/autorizacaoConsignataria/liberarAcesso`,
      autorizacaoPortabilidade,
    )
    return data
  }

  async listarConsignatariasComAutorizacao(servidorId) {
    const { data } = await this._http.get(
      `/api/autorizacaoConsignataria/${servidorId}`,
    )
    return data
  }

  async consignatariaEstaAutorizada(servidorId, consignatariaId) {
    const { data } = await this._http.get(
      `/api/autorizacaoConsignataria/${servidorId}/consignataria/${consignatariaId}`,
    )
    return data
  }

  async consignatariaEstaAutorizadaValorParcela(servidorId, consignatariaId) {
    const { data } = await this._http.get(
      `/api/autorizacaoConsignataria/${servidorId}/consignataria/valorParcela/${consignatariaId}`,
    )
    return data
  }
}
